import { Box, Grid, IconButton, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import ButtonContained from '../../../Common/ButtonContained';
import CommonTable from '../../../Common/CommonTable';
import DataNotFound from '../../../Common/DataNotFound';
import StyledTableCell from '../../../Common/styledTableCell';
import CustomPagination from '../../../Common/CommonPagination';
import CustomDialog from '../../../Common/CustomDialog';
import CommonTextField from '../../../Common/CommonTextField';
import TextLabel from '../../../Common/CommonTextLabel';
import { useTheme } from '@emotion/react';
import { showLoader } from '../../../../Redux/Slices/loaderSlice';
import { addOccupation, deleteOccupation, getOccupation, updateOccupation } from '../../../../Redux/Actions/action';
import { toast } from 'react-toastify';
import ErrorHandler from '../../../../Utils/handler';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const headerList = ["No", "Occupation Name", "Edit", "Delete"]
const Occupation = () => {
    // ---------- HOOK ------------
    const theme = useTheme()
    const dispatch = useDispatch()

    // ---------- State ------------
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({ occupation: "" });
    const [occupationList, setOccupationList] = useState({});
    const [error, setError] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    // ------------ handelChange --------------
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value.trimStart() });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    const handleClear = () => {
        setOpen(false);
        setIsEdit(false);
        setData({});
        setError({})
    };

    const validation = () => {
        let isValid = true;
        let error = {}
        if (!data.occupation) {
            error.occupation = "Occupation Name is required";
            isValid = false;
        }
        setError(error);
        return isValid;
    }

    //  ------------- API ----------------
    const _getOccupation = async () => {
        dispatch(showLoader(true))
        let body = {
            page: page,
            limit: rowsPerPage
        }
        try {
            const result = await dispatch(getOccupation(body));
            const error = ErrorHandler(result);
            if (error) {
                setOccupationList(result?.payload?.data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false))
        }
    }

    const _createUpdateOccupation = async () => {
        if (validation()) {
            dispatch(showLoader(true))
            try {
                let body = {
                    occupation: data?.occupation,
                }
                if (isEdit && data?._id) {
                    body._id = data?._id;
                }
                const fn = isEdit ? updateOccupation : addOccupation
                const result = await dispatch(fn(body))
                const error = ErrorHandler(result)
                if (error) {
                    toast.success(result?.payload?.message);
                    _getOccupation()
                    handleClear()
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false))
            }
        }
    }

    const _deleteOccupation = async (id) => {
        dispatch(showLoader(true))
        try {
            const result = await dispatch(deleteOccupation(id));
            const error = ErrorHandler(result);
            if (error) {
                toast.success(result?.payload?.message);
                _getOccupation()
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false))
        }
    }

    // ------------ useEffect ------------
    useEffect(() => {
        _getOccupation()
    }, [page, rowsPerPage])

    return (
        <>
            <Grid container spacing={1} xs={12}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>Occupation</Typography>
                        <ButtonContained text={'Add Occupation'} onClick={() => setOpen(true)} />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <CommonTable
                        headerList={headerList}
                        minWidth={400}
                    >
                        {occupationList?.response?.length > 0 ? occupationList?.response?.map((banner, index) => (
                            <TableRow key={banner.id}>
                                <StyledTableCell align="center">{(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}</StyledTableCell>
                                <StyledTableCell align="center">{banner?.occupation}</StyledTableCell>
                                <StyledTableCell align="center">
                                    <IconButton sx={{ padding: 0 }} onClick={() => {
                                        setOpen(true);
                                        setIsEdit(true);
                                        setData(banner)
                                    }} >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <IconButton sx={{ padding: 0 }} onClick={() => {
                                        console.log(banner?._id, 'ifddddd')
                                        _deleteOccupation(banner?._id)
                                    }} >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </StyledTableCell>
                            </TableRow>
                        )) :
                            (
                                <TableRow>
                                    <StyledTableCell colSpan={8}>
                                        <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                                    </StyledTableCell>
                                </TableRow>
                            )
                        }
                    </CommonTable>
                    {occupationList?.count > 0 &&
                        <Grid item xs={12}>
                            <CustomPagination
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                count={Math.ceil(occupationList?.count / rowsPerPage)}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage} />

                        </Grid>
                    }
                </Grid>
                {open && <CustomDialog
                    isOpen={open} handleClose={handleClear} title={isEdit ? 'Update Occupation' : 'Add Occupation'} padding={'10px'}
                    width={400}
                    action={
                        <>
                            <ButtonContained
                                text={isEdit ? 'Update Occupation' : 'Add Occupation'}
                                onClick={() => {
                                    _createUpdateOccupation()
                                }}
                                minWidth={'100%'}
                                marginTop={'10px'}

                            />
                        </>}
                >
                    <Grid container spacing={2} xs={12} ml={-1}>
                        <Grid item xs={12}>
                            <CommonTextField
                                value={data?.occupation}
                                width={"100%"}
                                text="Occupation"
                                type="text"
                                onChange={(e) => handleInputChange(e)}
                                placeholder="Enter a Occupation Name"
                                name="occupation"
                                valid
                            />
                            <TextLabel
                                title={!data?.occupation ? error?.occupation : ""}
                                color="error"
                            />
                        </Grid>
                    </Grid>
                </CustomDialog>
                }

            </Grid>
        </>
    )
}

export default Occupation
